const React = require("react");
const T = require("prop-types");
const Classes = require("./styles.scss");
const Paper = require("material-ui/Paper").default;
const RaisedButton = require("material-ui/RaisedButton").default;
const FlatButton = require("material-ui/FlatButton").default;
const TransactionDialog = require("containers/TransactionDialog");
const WhatsIncludedDialog = require("containers/WhatsIncludedDialog");
const History = require("wiring/history");

const internals = {};

internals.paperStyle = {
    padding: "3rem",
    margin: "4rem 0"
};

internals.buttonLabelStyle = {
    textTransform: "inherit"
};

module.exports = class Pricing extends React.Component {
    static propTypes = {
        paymentOptions: T.array.isRequired,
        onAddCreditsClick: T.func.isRequired,
        onSeeWhatsIncluded: T.func.isRequired,
        isAuthenticated: T.bool.isRequired,
        location: T.object.isRequired
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            viewMoreTestimonials: false
        };
    }

    componentDidMount() {
        const { isAuthenticated, onAddCreditsClick } = this.props;
        window.scrollTo(0, 0);
        if (this.props.location.pathname.includes("pricing")) {
            History.replace(`/buycredits${this.props.location.search}`);
        }

        if (this.props.location.search.includes("checkout")) {
            if (isAuthenticated) {
                setTimeout(() => onAddCreditsClick(), 1000);
            } else {
                History.replace("/login", { redirect: "/buycredits?checkout" });
            }
        }
    }

    render() {
        const {
            isAuthenticated,
            onAddCreditsClick,
            onSeeWhatsIncluded
        } = this.props;
        const { viewMoreTestimonials } = this.state;

        const chooseCreditsBtn = (
            <RaisedButton
                label="Choose My Credit Pack"
                primary
                onClick={() => {
                    if (isAuthenticated) {
                        onAddCreditsClick();
                    } else {
                        History.push("/login", {
                            redirect: "/buycredits?checkout"
                        });
                    }
                }}
            />
        );

        const openCreditPurchaseModal = () => {
            if (isAuthenticated) {
                onAddCreditsClick();
            } else {
                History.push("/login", { redirect: "/buycredits?checkout" });
            }
        };

        const purchaseCreditsBtn = (
            <RaisedButton
                label="Buy Credits Now"
                primary
                onClick={openCreditPurchaseModal}
            />
        );

        const testimonials = [
            {
                text:
                    "MyBodyModel has been such a gift! Not only has it helped me see what might look better on my body (and not a model’s) but it has given me more confidence. Using the croquis has just been so much fun!!",
                name: "Candyce"
            },
            {
                text:
                    "By using MyBodyModel I was able to 'try on' a pattern before spending all that time and money to see if it was actually something that would look good on MY body. I am much more confident in sewing for myself again.",
                name: "Holly"
            },
            {
                text:
                    "MyBodyModel has helped me so much! From accepting my body and its unique quirks, to helping me organise and prioritise my makes, to drawing different design options before committing to the final version - I can no longer imagine sewing or knitting without it!",
                name: "Lauren"
            },
            {
                text:
                    "Before I would choose fabric based on pattern and color without much thought on what I would sew. Now, I can sketch out my desired wardrobe and choose fabric that complements the design. This saves a lot of time and money.",
                name: "D.N."
            },
            {
                text:
                    "It's made me more confident in making outfits that I love and I'm more body confident.",
                name: "Hanne"
            }
        ];

        const testimonialsMore = [
            {
                text:
                    "Having a custom fashion drawing figure based on my body measurements and proportions helped me gain so much perspective on my body. It allows me to play with fashion in a way that I would never allow myself before. If someone tells me they are thinking of getting My Body Model, I say Do It!",
                name: "Roxanne"
            },
            {
                text:
                    "I held off on getting MyBodyModel and now I regret not getting it sooner! I could have saved myself so much money and time drawing up patterns to potentially buy to have a good estimate on how they look on me-some thing you need to sketch to visualize.",
                name: "Marah"
            },
            {
                text:
                    "Using MyBodyModel has actually helped me to see what the patterns would look like on ME, or the adjustments I would need to make in order to suit them better to my body. It has saved me a lot of time and financial investment, while also inspiring my creativity.",
                name: "Lydia"
            },
            {
                text:
                    "It is saving me time and effort by making items that will work together. I am thinking more about what items I want to knit to go with outfits too. I didn't play with paper dolls as a child, but I am really enjoying them as an adult!",
                name: "G.S."
            },
            {
                text:
                    "By being able to draw ideas for garments on MyBodyModel I have not only saved money not buying patterns that I don’t like the look of on me (even though I LOVE them when I see other peoples’ versions), I’ve saved so much frustration in making up garments I already have fabric and pattern ideas for, but don’t love on me when I try sketching them out. It adds another whole dimension of satisfaction with my making by actually planning my makes to work together and use fabrics and patterns I already have on hand. I can’t recommend using MyBodyModel enough!",
                name: "Heather"
            },
            {
                text:
                    "When I was recovering from shoulder surgery this spring, I couldn't sew at all. But I could draw! I spent two months 'trying on' all sorts of patterns and fabrics. Using My Body Model, I got to try on styles that I wouldn't approach IRL. The 'paper doll' process helped boost my body confidence and push through style boundaries.",
                name: "M.J."
            }
        ];

        const renderTestimonial = t => (
            <p>
                <em>{t.text}</em> - {t.name}
            </p>
        );

        const seeMoreTestimonials = e => {
            this.setState({ viewMoreTestimonials: true });
            e.preventDefault();
        };

        return (
            <div className={Classes.purchaseGroup}>
                <Paper style={internals.paperStyle}>
                    <h1>Stock Up and Save</h1>
                    <br />
                    <p>
                        MyBodyModel pricing uses Credits. That's so you can get
                        a lower price per Credit when you purchase a discount
                        pack.
                    </p>
                    <p>
                        Expecting your body measurements to change? Get a
                        discount pack, and save leftover Credits for later.
                    </p>
                    <ul>
                        <li>1 Credit for $29</li>
                        <li>2 Credits for $39</li>
                        <li>5 Credits for $59</li>
                        <li>20 Credits for $199</li>
                    </ul>
                    <p>{chooseCreditsBtn}</p>
                    <p>
                        Credits are saved in your Account until you're ready to
                        Download your MyBodyModel printable &amp; digital
                        fashion sketchbook.{" "}
                        <FlatButton
                            primary
                            label="Click here to see what’s included."
                            labelStyle={internals.buttonLabelStyle}
                            onClick={onSeeWhatsIncluded}
                            className="whats-included"
                        />
                    </p>
                    <ul>
                        <li>A Basic Download costs 1 Credit.</li>
                        <li>A Premium Download costs 2 Credits.</li>
                        <li>Upgrading from Basic to Premium costs 1 Credit.</li>
                    </ul>
                </Paper>
                <Paper style={internals.paperStyle}>
                    <h2>What People Are Saying</h2>
                    <br />
                    {testimonials.map(renderTestimonial)}
                    {viewMoreTestimonials ? (
                        testimonialsMore.map(renderTestimonial)
                    ) : (
                        <p>
                            <a href="#" onClick={seeMoreTestimonials}>
                                See More Testimonials
                            </a>
                        </p>
                    )}
                </Paper>
                <div className={Classes.purchaseBottom}>
                    {purchaseCreditsBtn}
                </div>
                <TransactionDialog />
                <WhatsIncludedDialog
                    from="pricing"
                    openPurchaseDialog={openCreditPurchaseModal}
                />
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/pricing/components/Pricing.js